export const STATE_IDENTIFIER = {
  LOADER_IDENTIFIER: "loader",
  CONFIG_LIST: "configList",
  CALL_STATE: "callState",
};

export interface IUigpConfigurationItem {
  configuration: string;
  description: string;
  value: string;
}
